export default "__VITE_ASSET__DklPo2zF__"